module.exports = __webpack_public_path__ + "img/add-square.583ae9ff.svg";